import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { getTimezoneName } from '@calendly/timezone-tools'
import { FlexLayout } from '@calendly/ui/components/flex-layout'
import { BodyText, LabelText } from '@calendly/ui/components/typography'

import { useEventType } from 'features/event_type_provider'

const Spot = ({ groupedSpot }) => (
  <div>
    <BodyText>
      {groupedSpot.date}
    </BodyText>
    <BodyText size="medium">
      {HtmlParser(groupedSpot.spots.map((x) => x.start_time).join(' &#x2022 '))}
    </BodyText>
  </div>
)

export const AdhocAvailability = () => {
  const { grouped_spots: groupedSpots = [], timezone } = useEventType()

  return (
    <>
      <FlexLayout direction="column" gap="8">
        {groupedSpots.length > 0 && (groupedSpots.map((groupedSpot) => (
          <Spot
            key={groupedSpot.date}
            groupedSpot={groupedSpot}
          />
        )))}
      </FlexLayout>
      <FlexLayout direction="column" gap="4">
        <LabelText size="medium">{I18n.t('timezones.time_zone')}</LabelText>
        <BodyText size="medium">
          {getTimezoneName(timezone)}
        </BodyText>
      </FlexLayout>
    </>
  )
}
